import { apiFetchJson, apiGet, apiPost } from './api';

/**
 * Create a new revision for an integration
 */
export const createRevision = async (integrationId, revisionData = {}) => {
  return apiPost('/api/data-loads/revisions/', {
    integration: integrationId,
    status: 'DRAFT',
    ...revisionData,
  });
};

/**
 * Fetch revision configuration
 */
export const fetchRevisionConfig = async (revisionId) => {
  return apiGet(`/api/data-loads/revisions/${revisionId}/config/`);
};

/**
 * Update revision configuration
 */
export const updateRevisionConfig = async (revisionId, configData) => {
  return apiFetchJson(`/api/data-loads/revisions/${revisionId}/config/`, {
    method: 'PUT',
    body: JSON.stringify(configData),
  });
};

/**
 * Validate revision schema
 */
export const validateRevisionSchema = async (revisionId) => {
  return apiPost(`/api/data-loads/revisions/${revisionId}/validate_schema/`, {});
};

/**
 * Deploy a revision
 */
export const deployRevision = async (revisionId) => {
  return apiPost(`/api/data-loads/revisions/${revisionId}/deploy/`, {});
};

/**
 * Run test on a revision
 */
export const runRevisionTest = async (revisionId, testFileUri) => {
  return apiPost(`/api/data-loads/revisions/${revisionId}/run_test/`, {
    test_file_uri: testFileUri,
  });
};

/**
 * Archive (delete) a revision
 */
export const archiveRevision = async (revisionId) => {
  return apiFetchJson(`/api/data-loads/revisions/${revisionId}/`, {
    method: 'DELETE',
  });
};
